import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Alarm = () => {
  const [hour, setHour] = React.useState(0);
  const [minute, setMinute] = useState(0);
  const [pm, setPm] = useState(false);
  useEffect(() => {

    const update = () => {
      const date = new Date();
      let hour = date.getHours();
      hour = (hour % 12) || 12;
      setHour(hour);
      setMinute(date.getMinutes());
      setPm(date.getHours() >= 12);
    };

    update();

    const interval = setInterval(() => {
      update();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container>
      <div className="today digital">{moment().format('ddd, MMM D, YYYY')}</div>
      <div className="time-container">
        <span className='digital'>{String(hour).padStart(2, '0')}:{String(minute).padStart(2, '0')}</span>
        <span className='digital'>{pm ? 'PM' : 'AM'}</span>
      </div>
    </Container>
  );
};

export default Alarm;

const Container = styled.div`
display: flex;
gap: 32px;
justify-content: space-between;
white-space: nowrap;

.digital {
    line-height: 55px;
    height: 48px;
    color: #FBE696;
    font-family: 'Digital-7';
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    word-spacing: -15px;
}
.time-container {
  display: flex;
  gap: 8px;
  align-items: flex-end;
  .digital {
    word-spacing: unset;
  }
}

`;
